import Component from './order-completed'

export default Component